import PropTypes from 'prop-types';

const ActionButtonPropType = {
  enableRightDrawerMessage: PropTypes.func.isRequired,
  handleRenderComponent: PropTypes.func,
};

export default ActionButtonPropType;
